import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import AboutUs from './Pages/AboutUs';
import MyProducts from './Pages/MyProducts';
import ContactForm from './Pages/ContactUs';
import MyProducts2 from './Pages/MyProducts2';
import TradingSection from './Components/Carousal/Test';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home></Home>} ></Route>
        <Route path='/aboutus' element={<AboutUs></AboutUs>} ></Route>
        <Route path='/sonxproducts' element={<MyProducts></MyProducts>} ></Route>
        <Route path='/contactus' element={<ContactForm></ContactForm>} ></Route>
        <Route path='/foodproducts' element={<MyProducts2></MyProducts2>} ></Route>
        <Route path='/test' element={<TradingSection></TradingSection>} ></Route>



      </Routes>
    </div>
  );
}

export default App;
